<template>

    <Toast/>

    <MenuSimple/>
    <HeadingForms/>

    <div class="px-6 surface-overlay relative">

        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div v-show="formReference==='0'" class="surface-section px-4 py-8 md:px-6 lg:px-8">
                        <div class="text-700 text-center">
                            <div class="text-900 font-bold text-5xl mb-3">Invalid Form</div>
                            <div class="text-700 text-2xl mb-5">Please recheck the details.</div>
                        </div>
                    </div>

                    <div v-show="formReference!='0'" class="surface-section px-4 py-8 md:px-6 lg:px-8">

                        <div class="text-700 text-center">
                            <div class="text-900 font-bold text-5xl mb-3">Couples Client Intake for {{
                                    this.companyName
                                }}
                            </div>

                            <div class="text-700 text-2xl mb-3">Enter your details below</div>

                        </div>
                    </div>


                    <div v-show="formReference!='0'" class="col-12 md:col-12">
                        <div class="card p-fluid">

                            <h2>Personal Details for Partner #1</h2>

                            <div class="field">
                                <label for="firstName">First Name</label>
                                <InputText id="firstName" v-model.trim="formData.firstName" required="true"/>
                            </div>

                            <div class="field">
                                <label for="lastName">Last Name</label>
                                <InputText id="lastName" v-model.trim="formData.lastName" required="true"/>
                            </div>

                            <div class="field">
                                <label for="preferredName">Preferred Name</label>
                                <InputText id="preferredName" v-model.trim="formData.preferredName" required="false"/>
                            </div>

                            <div class="field">
                                <label for="email">Email</label>
                                <InputText id="email" v-model.trim="formData.email" required="true"/>
                            </div>

                            <div class="field">
                                <label for="mobile">Mobile</label>
                                <InputText id="mobile" v-model.trim="formData.mobile" required="true"/>
                            </div>

                            <div class="field">
                                <label for="phone">Alternate Phone Number</label>
                                <InputText id="phone" v-model.trim="formData.phone" required="true"/>
                            </div>

                            <div class="field">
                                <label for="dob">Date of Birth</label>
                                <Calendar id="dob" v-model="formData.dob" dateFormat="yy-mm-dd"/>
                            </div>

                            <div class="field">
                                <label for="idNumber">ID Number</label>
                                <InputText id="idNumber" v-model.trim="formData.idNumber" required="true"/>
                            </div>

                            <div class="field">
                                <label for="gender">Gender</label>
                                <Dropdown v-model="formData.gender" :options="genderTypes" optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select a Gender"/>
                            </div>

                            <div v-show="formData.gender==='O'" class="field">
                                <label for="genderOther">Please Specify Gender Type</label>
                                <InputText id="genderOther" v-model.trim="formData.genderOther" required="true"/>
                            </div>

                            <div class="field">
                                <label for="addressCountry">Country</label>
                                <Dropdown v-model="formData.addressCountry" :options="countries"
                                          optionLabel="name" optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="address1">Address Line 1</label>
                                <InputText id="address1" v-model.trim="formData.address1"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="address2">Address Line 2</label>
                                <InputText id="address2" v-model.trim="formData.address2"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="addressRegion">Region</label>
                                <InputText id="addressRegion"
                                           v-model.trim="formData.addressRegion"
                                           required="true"/>
                            </div>

                            <div v-show="formData.addressCountry==='ZA'" class="field">
                                <label for="addressState">Province</label>
                                <Dropdown v-model="formData.addressState" :options="regionsSouthAfrica"
                                          optionLabel="name" optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div v-show="formData.addressCountry==='UK'" class="field">
                                <label for="addressState">County</label>
                                <InputText id="addressState" v-model.trim="formData.addressState"
                                           required="true"/>
                            </div>

                            <div v-show="formData.addressCountry!='ZA' && formData.addressCountry!='UK'" class="field">
                                <label for="addressState">State</label>
                                <InputText id="addressState" v-model.trim="formData.addressState"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="addressPostalCode">Postal Code</label>
                                <InputText id="addressPostalCode"
                                           v-model.trim="formData.addressPostalCode"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="mailingList">Can We Add You to our Mailing List?</label>
                                <Dropdown v-model="formData.mailingList" :options="confirmationTypes" optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="responsiblePerson">Are You Responsible for the Payment of this
                                    Account?</label>
                                <Dropdown v-model="formData.responsiblePerson" :options="confirmationTypes"
                                          optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="paymentMethod">Payment Method?</label>
                                <Dropdown v-model="formData.paymentMethod" :options="paymentTypes" optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <h2>Personal Details for Partner #2</h2>

                            <div class="field">
                                <label for="firstNamePartner2">First Name</label>
                                <InputText id="firstNamePartner2" v-model.trim="formData.firstNamePartner2"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="lastNamePartner2">Last Name</label>
                                <InputText id="lastNamePartner2" v-model.trim="formData.lastNamePartner2"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="preferredNamePartner2">Preferred Name</label>
                                <InputText id="preferredNamePartner2" v-model.trim="formData.preferredNamePartner2"
                                           required="false"/>
                            </div>

                            <div class="field">
                                <label for="emailPartner2">Email</label>
                                <InputText id="emailPartner2" v-model.trim="formData.emailPartner2" required="true"/>
                            </div>

                            <div class="field">
                                <label for="mobilePartner2">Mobile</label>
                                <InputText id="mobilePartner2" v-model.trim="formData.mobilePartner2" required="true"/>
                            </div>

                            <div class="field">
                                <label for="phonePartner2">Alternate Phone Number</label>
                                <InputText id="phonePartner2" v-model.trim="formData.phonePartner2" required="true"/>
                            </div>

                            <div class="field">
                                <label for="dobPartner2">Date of Birth</label>
                                <Calendar id="dobPartner2" v-model="formData.dobPartner2" dateFormat="yy-mm-dd"/>
                            </div>

                            <div class="field">
                                <label for="idNumberPartner2">ID Number</label>
                                <InputText id="idNumberPartner2" v-model.trim="formData.idNumberPartner2"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="genderPartner2">Gender</label>
                                <Dropdown v-model="formData.genderPartner2" :options="genderTypes" optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select a Gender"/>
                            </div>

                            <div v-show="formData.genderPartner2==='O'" class="field">
                                <label for="genderOtherPartner2">Please Specify Gender Type</label>
                                <InputText id="genderOtherPartner2" v-model.trim="formData.genderOtherPartner2"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="addressCountryPartner2">Country</label>
                                <Dropdown v-model="formData.addressCountryPartner2" :options="countries"
                                          optionLabel="name" optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="address1Partner2">Address Line 1</label>
                                <InputText id="address1Partner2" v-model.trim="formData.address1Partner2"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="address2Partner2">Address Line 2</label>
                                <InputText id="address2Partner2" v-model.trim="formData.address2Partner2"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="addressRegionPartner2">Region</label>
                                <InputText id="addressRegionPartner2"
                                           v-model.trim="formData.addressRegionPartner2"
                                           required="true"/>
                            </div>

                            <div v-show="formData.addressCountryPartner2==='ZA'" class="field">
                                <label for="addressStatePartner2">Province</label>
                                <Dropdown v-model="formData.addressStatePartner2" :options="regionsSouthAfrica"
                                          optionLabel="name" optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div v-show="formData.addressCountryPartner2==='UK'" class="field">
                                <label for="addressStatePartner2">County</label>
                                <InputText id="addressStatePartner2" v-model.trim="formData.addressStatePartner2"
                                           required="true"/>
                            </div>

                            <div v-show="formData.addressCountryPartner2!='ZA' && formData.addressCountryPartner2!='UK'"
                                 class="field">
                                <label for="addressStatePartner2">State</label>
                                <InputText id="addressStatePartner2" v-model.trim="formData.addressStatePartner2"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="addressPostalCodePartner2">Postal Code</label>
                                <InputText id="addressPostalCodePartner2"
                                           v-model.trim="formData.addressPostalCodePartner2"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="mailingListPartner2">Can We Add You to our Mailing List?</label>
                                <Dropdown v-model="formData.mailingListPartner2" :options="confirmationTypes"
                                          optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="responsiblePersonPartner2">Are You Responsible for the Payment of this
                                    Account?</label>
                                <Dropdown v-model="formData.responsiblePersonPartner2" :options="confirmationTypes"
                                          optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="paymentMethodPartner2">Payment Method?</label>
                                <Dropdown v-model="formData.paymentMethodPartner2" :options="paymentTypes"
                                          optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <br v-show="(formData.responsiblePerson === 'N') && (formData.responsiblePersonPartner2 === 'N')">
                            <br v-show="(formData.responsiblePerson === 'N') && (formData.responsiblePersonPartner2 === 'N')">

                            <h2 v-show="(formData.responsiblePerson === 'N') && (formData.responsiblePersonPartner2 === 'N')">
                                Person Responsible for Account</h2>

                            <div
                                v-show="(formData.responsiblePerson === 'N') && (formData.responsiblePersonPartner2 === 'N')"
                                class="field">
                                <label for="responsibleFirstName">First Name</label>
                                <InputText id="responsibleFirstName" v-model.trim="formData.responsibleFirstName"
                                           required="true"/>
                            </div>

                            <div
                                v-show="(formData.responsiblePerson === 'N') && (formData.responsiblePersonPartner2 === 'N')"
                                class="field">
                                <label for="responsibleFirstName">Last Name</label>
                                <InputText id="responsibleFirstName" v-model.trim="formData.responsibleFirstName"
                                           required="true"/>
                            </div>

                            <div
                                v-show="(formData.responsiblePerson === 'N') && (formData.responsiblePersonPartner2 === 'N')"
                                class="field">
                                <label for="responsibleEmail">Email Address</label>
                                <InputText id="responsibleEmail" v-model.trim="formData.responsibleEmail"
                                           required="true"/>
                            </div>

                            <div
                                v-show="(formData.responsiblePerson === 'N') && (formData.responsiblePersonPartner2 === 'N')"
                                class="field">
                                <label for="responsibleMobile">Mobile Number</label>
                                <InputText id="responsibleMobile" v-model.trim="formData.responsibleMobile"
                                           required="true"/>
                            </div>

                            <div
                                v-show="(formData.responsiblePerson === 'N') && (formData.responsiblePersonPartner2 === 'N')"
                                class="field">
                                <label for="responsibleWorkNumber">Work Contact Number</label>
                                <InputText id="responsibleWorkNumber" v-model.trim="formData.responsibleWorkNumber"
                                           required="true"/>
                            </div>

                            <div
                                v-show="(formData.responsiblePerson === 'N') && (formData.responsiblePersonPartner2 === 'N')"
                                class="field">
                                <label for="responsibleCompanyName">Company Work Name</label>
                                <InputText id="responsibleCompanyName" v-model.trim="formData.responsibleCompanyName"
                                           required="true"/>
                            </div>

                            <div
                                v-show="(formData.responsiblePerson === 'N') && (formData.responsiblePersonPartner2 === 'N')"
                                class="field">
                                <label for="responsibleCompanyAddress">Company Work Address</label>
                                <InputText id="responsibleCompanyAddress"
                                           v-model.trim="formData.responsibleCompanyAddress"
                                           required="true"/>
                            </div>

                            <div
                                v-show="(formData.responsiblePerson === 'N') && (formData.responsiblePersonPartner2 === 'N')"
                                class="field">
                                <label for="responsibleRelationship">Relationship to Patient</label>
                                <InputText id="responsibleRelationship" v-model.trim="formData.responsibleRelationship"
                                           required="true"/>
                            </div>

                            <br v-show="formData.paymentMethod === 'M'">
                            <br v-show="formData.paymentMethod === 'M'">

                            <h2 v-show="formData.paymentMethod === 'M'">Medical Aid Details</h2>

                            <div v-show="formData.paymentMethod === 'M'" class="field">
                                <label for="medicalAidName">Medical Aid / Funder Name</label>
                                <InputText id="medicalAidName" v-model.trim="formData.medicalAidName" required="true"/>
                            </div>

                            <div v-show="formData.paymentMethod === 'M'" class="field">
                                <label for="medicalAidPlan">Medical Aid / Funder Plan</label>
                                <InputText id="medicalAidPlan" v-model.trim="formData.medicalAidPlan" required="true"/>
                            </div>

                            <div v-show="formData.paymentMethod === 'M'" class="field">
                                <label for="medicalAidNumber">Medical Aid Number</label>
                                <InputText id="medicalAidNumber" v-model.trim="formData.medicalAidNumber"
                                           required="true"/>
                            </div>

                            <div v-show="formData.paymentMethod === 'M'" class="field">
                                <label for="mainMemberName">Main Member Full Name</label>
                                <InputText id="mainMemberName" v-model.trim="formData.mainMemberName" required="true"/>
                            </div>

                            <div v-show="formData.paymentMethod === 'M'" class="field">
                                <label for="mainMemberCode">Main Member Code</label>
                                <InputText id="mainMemberCode" v-model.trim="formData.mainMemberCode" required="true"/>
                            </div>

                            <div v-show="formData.paymentMethod === 'M'" class="field">
                                <label for="mainMemberIdNumber">Main Member ID Number</label>
                                <InputText id="mainMemberIdNumber" v-model.trim="formData.mainMemberIdNumber"
                                           required="true"/>
                            </div>

                            <div v-show="formData.paymentMethod === 'M'" class="field">
                                <label for="mainMemberEmail">Main Member Email</label>
                                <InputText id="mainMemberEmail" v-model.trim="formData.mainMemberEmail"
                                           required="true"/>
                            </div>

                            <div v-show="formData.paymentMethod === 'M'" class="field">
                                <label for="mainMemberMobile">Main Member Mobile</label>
                                <InputText id="mainMemberMobile" v-model.trim="formData.mainMemberMobile"
                                           required="true"/>
                            </div>

                            <div v-show="formData.paymentMethod === 'M'" class="field">
                                <label for="dependantName">Dependant Full Name</label>
                                <InputText id="dependantName" v-model.trim="formData.dependantName" required="true"/>
                            </div>

                            <div v-show="formData.paymentMethod === 'M'" class="field">
                                <label for="dependantCode">Dependant Code</label>
                                <InputText id="dependantCode" v-model.trim="formData.dependantCode" required="true"/>
                            </div>

                            <div v-show="formData.paymentMethod === 'M'" class="field">
                                <label for="referringDoctor">Referring Doctor</label>
                                <InputText id="referringDoctor" v-model.trim="formData.referringDoctor"
                                           required="true"/>
                            </div>

                            <br><br>
                            <h2>Additional Information</h2>

                            <div class="field">
                                <label for="reasonForVisit">Reason For Visit</label>
                                <InputText id="reasonForVisit" v-model.trim="formData.reasonForVisit" required="true"/>
                            </div>

                            <div class="field">
                                <label for="referralSource">Who Referred You or How Did You Hear About Us?</label>
                                <InputText id="referralSource" v-model.trim="formData.referralSource" required="true"/>
                            </div>

                            <br><br>
                            <h2>Consent</h2>

                            <h3>Important Practice Policies</h3>
                            <p>
                                1. As we work on an appointment based schedule, we ask that you please be on time for
                                your
                                appointments. If you are late for a session it will still end at the scheduled time.
                                If you are more than 15 minutes late for a session, it will be considered a no-show and
                                you will be
                                required to pay the fee for the session.
                                Cancellations should be made at least 24 hours before the scheduled appointment. Failure
                                to cancel a
                                session within this time will result in you being charged for the session.
                                Should you wish to reschedule an appointment, a minimum of 4 hours notice is required.
                                We will do
                                our best to accommodate this.
                                <BR/><BR/>
                                2. We are contracted in and charge medical aid rates. Please note the following - we
                                will submit your account
                                to your medical insurer on your behalf but if your account is rejected
                                by your insurer or partially paid, you will be responsible for the outstanding amount.
                                It is your responsibility to check with your medical aid to confirm your available
                                benefits.
                                It is your responsibility to make sure that we have the necessary authorisation numbers
                                if required
                                by your scheme.
                                You can request a full copy of our terms and conditions by sending an email to the
                                practitioner. Please familiarise yourself with these.
                            </p>

                            <br><br>
                            <div class="field">
                                <label for="diagnosisCodePermission">Do you give permission for the practitioner
                                    to submit the diagnosis code/s to medical aid?</label>
                                <Dropdown v-model="formData.diagnosisCodePermission" :options="confirmationTypes"
                                          optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="billingCompanyPermission">I have understood that the practitioner
                                    may make use of an external practice administration company
                                    and grant permission for them to contact me in regards to any queries about my
                                    account.</label>
                                <Dropdown v-model="formData.billingCompanyPermission" :options="confirmationTypes"
                                          optionLabel="name" required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="softwarePermission">I have understood that the practitioner
                                    may make use of a billing, accounting
                                    and/or practice management software.</label>
                                <Dropdown v-model="formData.softwarePermission" :options="confirmationTypes"
                                          optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="termsPermission">I hereby declare that the information given in this form is
                                    true and
                                    correct to the best of
                                    my knowledge and belief.</label>
                                <Dropdown v-model="formData.termsPermission" :options="confirmationTypes"
                                          optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <Button
                                v-show="formData.diagnosisCodePermission === 'N' || formData.billingCompanyPermission === 'N' || formData.softwarePermission === 'N' || formData.softwarePermission === 'N' || formData.termsPermission === 'N'"
                                label="Save" class="mr-2 mb-2" @click="saveForm" :disabled="true"></Button>

                            <Button
                                v-show="formData.diagnosisCodePermission === 'Y' && formData.billingCompanyPermission === 'Y'&& formData.softwarePermission === 'Y' && formData.termsPermission === 'Y'"
                                label="Save" class="mr-2 mb-2" @click="saveForm" :disabled="false"></Button>

                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import MenuSimple from "@/components/menu/common/MenuSimple.vue";
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import HeadingForms from "@/components/heading/common/HeadingForms.vue";
import UserService from "@/service/UserService";
import CompanyService from "@/service/CompanyService";
import moment from "moment/moment";
import ClientService from "@/service/ClientService";


export default {
    name: "ClientIntakeCouples",
    components: {
        MenuSimple,
        HeadingForms,
        IsoEvolveFooter,
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[Form][mounted] System is active.");
                console.log("[Form][mounted] Data = ", data);

                this.formReference = this.$route.query.reference;
                this.formData.addressCountry = 'ZA';
                this.formData.addressState = 'Gauteng';
                this.formData.diagnosisCodePermission = 'Y';
                this.formData.billingCompanyPermission = 'Y';
                this.formData.softwarePermission = 'Y';
                this.formData.termsPermission = 'Y';

                this.formData.mailingList = 'Y';
                this.formData.responsiblePerson = 'Y';
                this.formData.paymentMethod = 'M';
                this.formData.gender = 'M';

                console.log("[Booking] Company Reference (as per route parameter) = ", this.$route.query.reference);

                // CompanyService.getCompany(this.$route.query.reference)

                CompanyService.getCompany(this.$route.query.reference)
                    .then(data => {
                        this.company = data.data;
                        this.companyName = this.company.name;
                        console.log("[" + name + "][Booking] Got company data = ", this.company);

                    })
                    .catch(e => {
                        console.log("[" + name + "][Booking] Could not get data for company with ID = ", this.$route.query.reference);
                        console.log("[" + name + "][callViewBillingPlanComponents] Error = ", e);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Unsuccessful',
                            detail: 'Company NOT Found',
                            life: 3000
                        });

                        window.location.href = "/#/login";
                        window.location.reload();

                    });


            }).catch(e => {
            console.log("[Form][mounted] System is NOT active.");
            console.log("[Form][mounted] Error = ", e);

            window.location.href = "/#/login";
            window.location.reload();
        });
    },
    data() {
        return {
            userData: {},
            company: {},
            submitted: false,
            form: {},
            formData: {},
            companyName: null,
            practitioners: null,
            locations: null,
            newFormComponents: [],
            newForm: {},
            formOwner: "0",
            genderTypes: [
                {name: 'Male', code: 'M'},
                {name: 'Female', code: 'F'},
                {name: 'Other', code: 'O'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            parentTypes: [
                {name: 'Mother', code: 'M'},
                {name: 'Father', code: 'F'}
            ],
            paymentTypes: [
                {name: 'Medical Aid', code: 'M'},
                {name: 'Cash', code: 'C'}
            ],
            countries: [
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'India', code: 'IN'},
                {name: 'United States', code: 'US'},
                {name: 'Canada', code: 'CA'},
                {name: 'Namibia', code: 'NA'},
                {name: 'Australia', code: 'AU'},
                {name: 'New Zealand', code: 'NZ'},
                {name: 'Brazil', code: 'BR'},
                {name: 'China', code: 'CN'},
                {name: 'Egypt', code: 'EG'},
                {name: 'France', code: 'FR'},
                {name: 'Germany', code: 'DE'},
                {name: 'Japan', code: 'JP'},
                {name: 'Spain', code: 'ES'},
                {name: 'Slovenia', code: 'SV'},
            ],
            regionsSouthAfrica: [
                {name: 'Gauteng', code: 'Gauteng'},
                {name: 'Western Cape', code: 'Western Cape'},
                {name: 'Kwa-Zulu Natal', code: 'Kwa-Zulu Natal'},
                {name: 'North-West', code: 'North-West'},
                {name: 'Free State', code: 'Free State'},
                {name: 'Eastern Cape', code: 'Eastern Cape'},
                {name: 'Mpumalanga', code: 'Mpumalanga'},
                {name: 'Northern Cape', code: 'Northern Cape'},
                {name: 'Limpopo', code: 'Limpopo'}
            ]
        }
    }
    ,
    methods: {
        convertDatetoUtc(inputDate) {
            const formattedDateStr = inputDate.toLocaleString();

            return formattedDateStr;
        },
        saveForm() {
            console.log("[Form][saveForm] Start of function.");

            this.submitted = true;

            console.log("[Form][saveForm] this.formData.dob = ", this.formData.dob);

            if (this.formData.dob) {
                console.log("[Form][saveForm] convertDatetoUtc(this.formData.dob) = ", this.convertDatetoUtc(this.formData.dob));
            }

            this.newFormComponents = [
                {"name": "firstName", "value": this.formData.firstName},
                {"name": "lastName", "value": this.formData.lastName},
                {"name": "preferredName", "value": this.formData.preferredName},
                {"name": "email", "value": this.formData.email},
                {"name": "mobile", "value": this.formData.mobile},
                {"name": "dob", "value": moment(this.formData.dob).format('YYYY-MM-DD')},
                {"name": "idNumber", "value": this.formData.idNumber},
                {"name": "gender", "value": this.formData.gender},
                {"name": "genderOther", "value": this.formData.genderOther},
                {"name": "address1", "value": this.formData.address1},
                {"name": "address2", "value": this.formData.address2},
                {"name": "addressRegion", "value": this.formData.addressRegion},
                {"name": "addressState", "value": this.formData.addressState},
                {"name": "addressCountry", "value": this.formData.addressCountry},
                {"name": "addressPostalCode", "value": this.formData.addressPostalCode},
                {"name": "mailingList", "value": this.formData.mailingList},
                {"name": "responsiblePerson", "value": this.formData.responsiblePerson},
                {"name": "paymentMethod", "value": this.formData.paymentMethod},

                {"name": "firstNamePartner2", "value": this.formData.firstNamePartner2},
                {"name": "lastNamePartner2", "value": this.formData.lastNamePartner2},
                {"name": "preferredNamePartner2", "value": this.formData.preferredNamePartner2},
                {"name": "emailPartner2", "value": this.formData.emailPartner2},
                {"name": "mobilePartner2", "value": this.formData.mobilePartner2},
                {"name": "dobPartner2", "value": moment(this.formData.dobPartner2).format('YYYY-MM-DD')},
                {"name": "idNumberPartner2", "value": this.formData.idNumberPartner2},
                {"name": "genderPartner2", "value": this.formData.genderPartner2},
                {"name": "genderOtherPartner2", "value": this.formData.genderOtherPartner2},
                {"name": "address1Partner2", "value": this.formData.address1Partner2},
                {"name": "Partner2", "value": this.formData.address2Partner2},
                {"name": "addressRegionPartner2", "value": this.formData.addressRegionPartner2},
                {"name": "addressStatePartner2", "value": this.formData.addressStatePartner2},
                {"name": "addressCountryPartner2", "value": this.formData.addressCountryPartner2},
                {"name": "addressPostalCodePartner2", "value": this.formData.addressPostalCodePartner2},
                {"name": "mailingListPartner2", "value": this.formData.mailingListPartner2},
                {"name": "responsiblePersonPartner2", "value": this.formData.responsiblePersonPartner2},
                {"name": "paymentMethodPartner2", "value": this.formData.paymentMethodPartner2},

                {"name": "medicalAidName", "value": this.formData.medicalAidName},
                {"name": "medicalAidPlan", "value": this.formData.medicalAidPlan},
                {"name": "medicalAidNumber", "value": this.formData.medicalAidNumber},
                {"name": "mainMemberName", "value": this.formData.mainMemberName},
                {"name": "mainMemberCode", "value": this.formData.mainMemberCode},
                {"name": "mainMemberIdNumber", "value": this.formData.mainMemberIdNumber},
                {"name": "mainMemberEmail", "value": this.formData.mainMemberEmail},
                {"name": "mainMemberMobile", "value": this.formData.mainMemberMobile},
                {"name": "dependantName", "value": this.formData.dependantName},
                {"name": "dependantCode", "value": this.formData.dependantCode},
                {"name": "referringDoctor", "value": this.formData.referringDoctor},
                {"name": "reasonForVisit", "value": this.formData.reasonForVisit},
                {"name": "referralSource", "value": this.formData.referralSource},
                {"name": "diagnosisCodePermission", "value": this.formData.diagnosisCodePermission},
                {"name": "billingCompanyPermission", "value": this.formData.billingCompanyPermission},
                {"name": "softwarePermission", "value": this.formData.softwarePermission},
                {"name": "termsPermission", "value": this.formData.termsPermission}
            ];

            console.log("[Form][saveForm] Before update call. this.newFormComponents = ", this.newFormComponents);

            ClientService.processClientIntake(this.company.id, this.newFormComponents)
                .then(response => {
                    console.log("[" + name + "][saveForm] Response = ", response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Couples Client Intake Submitted',
                        life: 3000
                    });

                    // window.location.href = "/#/clientintakeSuccessful";
                    // window.location.reload();

                })
                .catch(e => {

                    console.log("[" + name + "][saveForm] Error = ", e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Unsuccessful',
                        detail: 'Couples Client Intake NOT Submitted',
                        life: 3000
                    });

                    // window.location.href = "/#/clientintakeError";
                    // window.location.reload();

                });

            this.formData.firstName = "";
            this.formData.lastName = "";
            this.formData.preferredName = "";
            this.formData.email = "";
            this.formData.mobile = "";
            this.formData.dob = "";
            this.formData.idNumber = "";
            this.formData.gender = "";
            this.formData.genderOther = "";
            this.formData.address1 = "";
            this.formData.address2 = "";
            this.formData.addressRegion = "";
            this.formData.addressState = "";
            this.formData.addressCountry = "";
            this.formData.addressPostalCode = "";
            this.formData.mailingList = "";
            this.formData.responsiblePerson = "";
            this.formData.paymentMethod = "";

            this.formData.firstNamePartner2 = "";
            this.formData.lastNamePartner2 = "";
            this.formData.preferredNamePartner2 = "";
            this.formData.emailPartner2 = "";
            this.formData.mobilePartner2 = "";
            this.formData.dobPartner2 = "";
            this.formData.idNumberPartner2 = "";
            this.formData.genderPartner2 = "";
            this.formData.genderOtherPartner2 = "";
            this.formData.address1Partner2 = "";
            this.formData.address2Partner2 = "";
            this.formData.addressRegionPartner2 = "";
            this.formData.addressStatePartner2 = "";
            this.formData.addressCountryPartner2 = "";
            this.formData.addressPostalCodePartner2 = "";
            this.formData.mailingListPartner2 = "";
            this.formData.responsiblePersonPartner2 = "";
            this.formData.paymentMethodPartner2 = "";

            this.formData.medicalAidName = "";
            this.formData.medicalAidPlan = "";
            this.formData.medicalAidNumber = "";
            this.formData.mainMemberName = "";
            this.formData.mainMemberCode = "";
            this.formData.mainMemberIdNumber = "";
            this.formData.mainMemberEmail = "";
            this.formData.mainMemberMobile = "";
            this.formData.dependantName = "";
            this.formData.dependantCode = "";
            this.formData.referringDoctor = "";
            this.formData.reasonForVisit = "";
            this.formData.referralSource = "";
            this.formData.emergencyContactFullName = "";
            this.formData.emergencyContactEmail = "";
            this.formData.emergencyContactMobile = "";
            this.formData.emergencyContactRelationship = "";
            this.formData.diagnosisCodePermission = "";
            this.formData.billingCompanyPermission = "";
            this.formData.softwarePermission = "";
            this.formData.termsPermission = "";
            this.newFormComponents = [];
            this.submitted = false;
        }

    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
